<template>
    <div
        class="modal fade"
        id="modal-select-prestas"
        tabindex="-1"
        aria-labelledby="modal-select-prestas"
        aria-hidden="true"
        role="dialog"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content rounded-24 overflow-hidden">
                <div class="block rounded-24 block-transparent mb-0">
                    <div class="block-header">
                        <h3 class="block-title">Sélectionner les prestations</h3>
                    </div>
                    <div v-if="selected" class="block-content fs-sm">
                        <span class="text-muted"
                            >Sélectionner les prestations auxquelles il faut appliquer : <b>{{ selected.name }}</b
                            >.</span
                        >
                        <div class="mt-3 mb-3">
                            <div v-for="(prestation, index) in prestations" :key="index">
                                <div class="form-check">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        value=""
                                        :id="'prestation_' + index"
                                        :name="'prestation_' + index"
                                        checked=""
                                        @change="selectPrestation($event, prestation, index)"
                                    />
                                    <label class="form-check-label" :for="'prestation_' + index">{{ prestation.name }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="block-content block-content-full text-center">
                        <button
                            type="button"
                            class="btn btn-sm btn-alt-danger text-danger me-1"
                            data-bs-dismiss="modal"
                            @click="() => $emit('remove-selected')"
                        >
                            Fermer
                        </button>
                        <button
                            type="button"
                            class=" btn btn-sm btn-primary text-white rounded-pill"
                            data-bs-dismiss="modal"
                            @click="addToPrepaidPrestations"
                        >
                            Valider
                        </button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { sync, get } from 'vuex-pathify'

export default {
    props: ['selected'],
    data: () => ({
        prestations: [],
    }),
    computed: {
        ...sync('overlay@data', {
            c_prepaidPrestations: 'prepaidPrestations',
        }),
        ...get('overlay@data', {
            c_cartItems: 'cartItems',
        }),
    },
    watch: {
        selected: {
            handler(newVal) {
                if (newVal) {
                    // reset des prestations à afficher dans la modal
                    this.prestations = []
                    this.checkIfSelectedContainsPresta(newVal)
                }
            },
            immediate: true,
        },
    },
    methods: {
        selectPrestation(event, prestation, index) {
            if (event.target.checked) {
                this.c_prepaidPrestations.push({
                    prestation: prestation,
                    prepaid: this.selected,
                })
            } else {
                this.c_prepaidPrestations.splice(index, 1)
            }
        },
        checkIfSelectedContainsPresta(item) {
            console.log(item)
            if (item)
                for (const key in this.c_cartItems) {
                    console.log(parseInt(this.c_cartItems[key].options.item_id))
                    // S'il y a des prestations qui appartiennent à un abonnement ou une cure
                    if (this.c_cartItems[key].options.type == 'App\\Models\\Prestation\\Prestation')
                        if (
                            item.prestations.filter(prestation => {
                                return prestation.id == parseInt(this.c_cartItems[key].options.item_id)
                            }).length > 0
                        ) {
                            // Si on a plusieurs prestations similaires
                            if (this.c_cartItems[key].qty > 1) {
                                for (var i = 0; i < this.c_cartItems[key].qty; i++) {
                                    this.prestations.push(this.c_cartItems[key])
                                    this.c_prepaidPrestations.push({
                                        prestation: this.c_cartItems[key],
                                        prepaid: this.selected,
                                    })
                                }
                            } else {
                                this.prestations.push(this.c_cartItems[key])
                                this.c_prepaidPrestations.push({
                                    prestation: this.c_cartItems[key],
                                    prepaid: this.selected,
                                })
                            }
                        }
                }
        },
    },
}
</script>

<style></style>
